import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { usePrivy } from "@privy-io/react-auth";
import { useStats } from "@/lib/hooks/useApi";
import { useNextStep } from "nextstepjs";
import { useEffect } from "react";

export const Route = createFileRoute("/about")({
  component: About,
});

function About() {
  const { user } = usePrivy();
  const { data: statsData } = useStats(user?.wallet?.address ?? "");
  const gameWalletAddress = statsData?.embeddedWallet;
  const { startNextStep, currentStep, closeNextStep } = useNextStep();
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Add a small delay to ensure DOM is ready
  //   const timer = setTimeout(() => {
  //     startNextStep("onboardingTour");
  //   }, 500);
  //
  //   return () => clearTimeout(timer);
  // }, [startNextStep]);

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="border-4 border-dashed border-gray-200 rounded-lg p-8">
            <div className="text-center">
              <h2
                className="text-2xl font-bold text-gray-900 mb-4"
                data-step="welcome"
              >
                About CFL Game
              </h2>
              <p className="text-gray-600 mb-6" data-step="game-info">
                Learn more about the CFL Game platform and your wallet.
              </p>

              <div
                className="bg-white p-6 rounded-lg shadow"
                data-step="wallet"
              >
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Your Wallet Address:
                </h3>
                <p className="font-mono text-sm text-gray-600 bg-gray-100 p-3 rounded break-all">
                  {gameWalletAddress}
                </p>
              </div>

              <div className="mt-6 space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-blue-900 mb-2">Features</h4>
                  <ul className="text-blue-800 text-sm space-y-1">
                    <li>• Create and manage your squad</li>
                    <li>• Participate in tournaments</li>
                    <li>• Battle other players in PvP mode</li>
                    <li>• Earn rewards and climb leaderboards</li>
                  </ul>
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-green-900 mb-2">
                    Benefits
                  </h4>
                  <ul className="text-green-800 text-sm space-y-1">
                    <li>• Receive tournament prizes</li>
                  </ul>
                </div>

                <div className="relative">
                  <button
                    className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors shadow-lg"
                    data-step="navigation"
                    onClick={() => {
                      // Only close tour if we're on the navigation step (last step)
                      if (currentStep === 3) { // 0-indexed, so step 4 is index 3
                        closeNextStep();
                        navigate({ to: "/home" });
                      }
                    }}
                  >
                    Navigation to Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
